import { css, cx } from 'linaria';
import { ChevronDownIcon } from 'components/icons/ChevronDownIcon';
import { usePopover, popoverBase } from 'components/popover/popover';
import { buttonReset } from 'components/buttons/button-reset';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';

// i.e., h3
const filterStyle = "fnu3mcy";
export function FilterMenu({
  subset,
  filter,
  tag,
  query
}) {
  const {
    t
  } = useTranslation();
  const hasFilter = ['search', 'favorites', 'highlights', 'articles', 'videos', 'tag'].includes(subset);
  const filterActive = filterLink => {
    const activeClass = filterLink === filter ? 'active' : '';
    return `${activeClass}`;
  };
  const filterTitles = {
    unread: t('nav:my-list', 'My List'),
    archive: t('nav:archive', 'Archive'),
    favorites: t('nav:favorites', 'Favorites')
  };
  const activeTitle = filterTitles[filter] || t('nav:all-items', 'All items');

  // Popover Effect
  const {
    popTrigger,
    popBody,
    shown
  } = usePopover({
    placement: 'bottom-start',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [-20, -26]
      }
    }]
  });
  const path = tag ? `tags/${tag}` : subset;
  const searchQuery = query ? `?query=${query}` : '';
  return hasFilter ? <div className={cx(filterStyle, 'filter-wrapper')}>
      <button ref={popTrigger} data-cy="filter-trigger" className={cx(buttonReset, 'filter-trigger')}>
        {activeTitle}
        <ChevronDownIcon style={{
        marginTop: 0,
        paddingLeft: '3px'
      }} />
      </button>
      {shown ? <div className="filter-menu" ref={popBody}>
          <div>
            <Link href={`/my-list/${path}${searchQuery}`}>
              <button className={filterActive()} data-cy="filter-all-items">
                <Trans i18nKey="nav:all-items">All items</Trans>
              </button>
            </Link>
          </div>
          <div>
            <Link href={`/my-list/${path}/unread${searchQuery}`}>
              <button className={filterActive('unread')} data-cy="filter-mylist">
                <Trans i18nKey="nav:my-list">My List</Trans>
              </button>
            </Link>
          </div>
          <div>
            <Link href={`/my-list/${path}/archive${searchQuery}`}>
              <button className={filterActive('archive')} data-cy="filter-archive">
                <Trans i18nKey="nav:archive">Archive</Trans>
              </button>
            </Link>
          </div>
          {path === 'favorites' || subset === 'search' ? null : <div>
              <Link href={`/my-list/${path}/favorites`}>
                <button className={filterActive('favorites')} data-cy="filter-favorites">
                  <Trans i18nKey="nav:favorites">Favorites</Trans>
                </button>
              </Link>
            </div>}
        </div> : null}
    </div> : null;
}

require("./list-filter-menu.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./list-filter-menu.js");